import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top instantly on route change
 * This runs before the page renders, ensuring smooth navigation
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly (not smooth) before page renders
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    // Also ensure document element is scrolled to top
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

export default ScrollToTop;

